var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllToPrimaryOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 21a2 2 0 100-4 2 2 0 000 4zm2.907-1.256A3.001 3.001 0 010 19a3 3 0 015.907-.744A.752.752 0 016 18.25H11.25c.181 0 .408-.114.662-.451a3.265 3.265 0 00.497-1.023L14.214 11 12.41 5.224l-.003-.01-.003-.01a3.264 3.264 0 00-.49-1.003c-.255-.336-.482-.451-.663-.451H6a.758.758 0 01-.093-.006A3.001 3.001 0 010 3a3 3 0 015.907-.744A.758.758 0 016 2.25H11.25c.87 0 1.486.552 1.86 1.049.38.503.62 1.087.734 1.487l1.708 5.464h4.543A3.001 3.001 0 0126 11a3 3 0 01-5.905.75h-4.543l-1.708 5.464c-.114.4-.355.984-.734 1.487-.374.497-.99 1.049-1.86 1.049H6a.752.752 0 01-.093-.006zM5 3a2 2 0 11-4 0 2 2 0 014 0zm20 8a2 2 0 11-4 0 2 2 0 014 0z",
    fill: "currentColor"
  })));
}
export default SvgAllToPrimaryOutline;